import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";

const { color, radius, typeScale } = adminTokens;
const [, , spaceMd] = adminTokens.spacing;

const DashedButton = styled.button`
  padding: ${spaceMd}px;
  border: 1px dashed ${color.border};
  border-radius: ${radius.row}px;
  background: none;
  color: ${color.inkSoft};
  font-family: ${typeScale.body.fontFamily};
  font-size: ${typeScale.body.fontSize};
  cursor: pointer;
`;

interface AddAddressButtonProps {
  isDisabled?: boolean;
  onClick: () => void;
}

// The dashed "+ Add a new address" Button below a list of addresses (SHIPUI-R23, USER-R23).
export const AddAddressButton = ({ isDisabled = false, onClick }: AddAddressButtonProps) => (
  <DashedButton type="button" disabled={isDisabled} onClick={onClick}>
    + Add a new address
  </DashedButton>
);
